import { render, staticRenderFns } from "./addEnterEditNew.vue?vue&type=template&id=2f64c194&scoped=true"
import script from "./addEnterEditNew.vue?vue&type=script&lang=js"
export * from "./addEnterEditNew.vue?vue&type=script&lang=js"
import style0 from "./addEnterEditNew.vue?vue&type=style&index=0&id=2f64c194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f64c194",
  null
  
)

export default component.exports